import { render, staticRenderFns } from "./liberacaoautomaticaconfig.vue?vue&type=template&id=1bfca7e0&scoped=true"
import script from "./liberacaoautomaticaconfig.vue?vue&type=script&lang=js"
export * from "./liberacaoautomaticaconfig.vue?vue&type=script&lang=js"
import style0 from "./liberacaoautomaticaconfig.vue?vue&type=style&index=0&id=1bfca7e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfca7e0",
  null
  
)

export default component.exports